module.exports = __webpack_public_path__ + "img/FR14568.5b781146.png";